import React, { useState } from 'react';
import classNames from 'classnames';
import { Modal  } from 'antd';
import Button from "components/button";

function ButtonWithConfirm({confirmHandler, children, confirmationMessage, className, confirmationTitle='Confirm Action', ...rest}) {
	
	const buttonClassName = classNames('me-3',className);
	const [open, setOpen] = useState(false);
	
	const processHandler = () => {
        if(confirmHandler){
            confirmHandler();
        }
        setOpen(false);
	};
	
    return (<>
    	<Button className={buttonClassName.trim()} 
    		{...rest}
    		onClick={(e) => {e.preventDefault();setOpen(true)}}
		>
  			{children}
		</Button> 
		<Modal
            open={open}
            closeIcon={false}
            centered
            title={<h2 className="popup-modal-title">{confirmationTitle}</h2>}
            okText="Confirm"
            cancelText="Cancel"
            footer={(_) => (
                <>
                    <Button className="me-4" 
                        onClick={() => {setOpen(false)}}
                    >
                        Cancel
                    </Button>
                    <Button className="btn-primary" 
                        onClick={processHandler}
                    >
                        Confirm
                    </Button>
                </>
            )}
        >
            <div className='content-wrapper'>
                {confirmationMessage && <div>{confirmationMessage}</div>}            
                <div>Are you sure you want to continue?</div>
            </div>
        </Modal>
    </>);
}

export default ButtonWithConfirm;



